<template>
    <form class="needs-validation" autocomplete="off">
        <div class="form-group row">
            <label class="col-sm-3" style="white-space: nowrap">{{ $t('document.deliveryCycle') }}</label>
            <div class="col-sm-8">
                <Multiselect :id="`select-cycle`" :value.sync="dataForm.cycle" :options="dataCycle" :config.sync="configFieldCycle" />
            </div>
        </div>

        <div v-if="dataForm.cycle?.id === 1" class="form-group row">
            <label class="col-sm-3" style="white-space: nowrap">{{ $t('document.closingDate') }} <span class="text-danger">*</span></label>
            <div class="col-sm-8">
                <Multiselect
                    :id="`select-closing-date`"
                    :value.sync="dataForm.closing_date"
                    :options="dataDayOfWeek"
                    :config.sync="configFieldClosingDate"
                />
            </div>
        </div>

        <div class="form-group row">
            <div class="col-sm-3">
                <label style="white-space: nowrap">{{ $t('document.reportDate') }} <span class="text-danger">*</span></label>
                <p class="mb-0" style="font-size: 13px">{{ $t('document.noteFMT') }}</p>
            </div>
            <div class="col-sm-8">
                <Multiselect
                    :id="`select-report-date`"
                    :value.sync="dataForm.report_date"
                    :options="REPORT_DATE"
                    :config="{
                        trackBy: '',
                        label: '',
                        error: false
                    }"
                />
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3" style="white-space: nowrap">{{ $t('document.skipTheFirstWeekClosing') }}</label>
            <div class="col-sm-8">
                <InputCheckBox
                    :model.sync="dataForm.skip_the_first_week_closing"
                    :id="`check-skip_the_first_week_closing`"
                    :value="dataForm.skip_the_first_week_closing"
                    :label="``"
                />
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3" style="white-space: nowrap">{{ $t('document.includeItOneWeekBefore') }}</label>
            <div class="col-sm-8">
                <InputCheckBox
                    :model.sync="dataForm.include_it_one_week_before"
                    :id="`check-include_it_one_week_before`"
                    :value="dataForm.include_it_one_week_before"
                    :label="``"
                />
            </div>
        </div>
    </form>
</template>

<script>
import Multiselect from '@/components/Multiselect/main.vue';

import { cycleFMT, DayOfWeek, findDeliveryCycle } from '@/views/pages/documents/main.js';
import { InputCheckBox } from '@/components/Input';
import { configs, REPORT_DATE } from '../../../main';
import { mapState } from 'vuex';

export default {
    name: 'TabConditionFMT',
    components: {
        Multiselect,
        InputCheckBox
    },
    props: {
        dataCondition: {
            type: Object,
            default: () => null
        },
        fmtConfig: {
            type: Object,
            default: () => null
        }
    },
    computed: {
        ...mapState({
            ...mapState('master', ['dataParamaterFMT'])
        })
    },
    data() {
        return {
            dataForm: {
                cycle: null,
                report_date: 3,
                closing_date: DayOfWeek[4],
                skip_the_first_week_closing: false,
                include_it_one_week_before: false
            },
            dataCycle: cycleFMT,
            dataDayOfWeek: DayOfWeek,
            configFieldCycle: configs.configFieldCycle,
            configFieldClosingDate: configs.configFieldClosingDate,
            REPORT_DATE: REPORT_DATE
        };
    },
    methods: {
        handleMapData() {
            this.dataForm = {
                ...this.dataForm,
                cycle: findDeliveryCycle(this.dataParamaterFMT?.delivery_cycle ?? this.fmtConfig.dataDocument.fmt_parameter_cycle),
                report_date: this.dataParamaterFMT?.report_day ?? 3,
                closing_date: this.dataParamaterFMT?.closing_day?.id ? this.dataParamaterFMT.closing_day : DayOfWeek[4],
                skip_the_first_week_closing: this.dataParamaterFMT?.is_skip_the_first_week,
                include_it_one_week_before: this.dataParamaterFMT?.is_merged_with_the_last_week
            };
            return this.dataForm;
        }
    },

    watch: {
        dataForm: {
            handler() {
                this.$emit('dataTabFMT', this.dataForm);
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
        this.dataForm = this.handleMapData();
    }
};
</script>

<style lang="scss" scoped></style>
